import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Clock3 } from "lucide-react";
import { Link } from "react-router-dom";

const NewsletterCard = ({ article, featured = false, linkBase = "/newsletter" }) => {
  return (
    <motion.article
      whileHover={{ y: -6 }}
      className={`overflow-hidden rounded-[22px] border border-purple-100 bg-white shadow-[0_18px_50px_rgba(123,31,162,0.08)] ${
        featured ? "lg:grid lg:grid-cols-[1.2fr_0.8fr]" : ""
      }`}
    >
      <div className={featured ? "h-full" : ""}>
        {article.coverImage ? (
          <img
            src={article.coverImage}
            alt={article.title}
            className={`w-full object-cover ${featured ? "h-full min-h-[260px]" : "h-44"}`}
          />
        ) : (
          <div
            className={`flex w-full items-end bg-[linear-gradient(135deg,#f8dbff_0%,#efe4ff_45%,#d9d7ff_100%)] p-5 ${
              featured ? "h-full min-h-[260px]" : "h-44"
            }`}
          >
            <div className="max-w-xs rounded-[18px] bg-white/70 p-4 backdrop-blur">
              <div className="text-[11px] font-bold uppercase tracking-[0.24em] text-purple-700">{article.category}</div>
              <div className="mt-2 font-heading text-xl font-black text-gray-900">{article.title}</div>
            </div>
          </div>
        )}
      </div>

      <div className="flex flex-col justify-between p-4 sm:p-5">
        <div>
          <div className="mb-3 flex flex-wrap items-center gap-2 text-xs sm:text-sm">
            <span className="rounded-full bg-purple-50 px-2.5 py-1 font-semibold text-purple-700">
              {article.category}
            </span>
            <span className="text-gray-500">{new Date(article.publishedAt).toLocaleDateString()}</span>
            <span className="inline-flex items-center gap-1 text-gray-500">
              <Clock3 className="h-4 w-4" />
              {article.readingTime} min read
            </span>
          </div>

          <h3 className={`font-heading font-black text-gray-900 ${featured ? "text-2xl sm:text-3xl" : "text-lg sm:text-xl"} mb-2`}>
            {article.title}
          </h3>
          <p className="text-sm leading-6 text-gray-600 sm:text-base sm:leading-7">{article.excerpt}</p>
          {!!article.tags?.length && (
            <div className="mt-4 flex flex-wrap gap-2">
              {article.tags.slice(0, featured ? 5 : 3).map((tag) => (
                <span key={tag} className="rounded-full border border-purple-100 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-gray-500">
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>

        <Link
          to={`${linkBase}/${article.slug}`}
          className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-purple-700"
        >
          Read full story
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </motion.article>
  );
};

export default NewsletterCard;
